"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The interface which describes the basic structure of aa response data from server.
 * @interface
 */
var ServiceResponse = /** @class */ (function () {
    function ServiceResponse() {
    }
    return ServiceResponse;
}());
exports.ServiceResponse = ServiceResponse;
//# sourceMappingURL=service-response.js.map